export default {
    env: 'prod',
    apiUrl: 'https://api.aw.dsha.info/api',

    //  Auth Stuff
    authDomain: 'auth.aw.dsha.info',
    authAudience: 'https://dsha-aw.tangatek.net/',
    authClientId: 'XebMAKQtkMAV7v5Ny7WIlvM3VKL3zbYt',
}